import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getAllCategories } from 'lib/api/tags';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import EnhancedTable from 'lib/designSystem/Table';
import { showAlert } from 'lib/functions/utils';
import CategorySummary from './CategorySummary';
import AddCategory from './AddCategory';

const Categories: React.FC = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState<any[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<any>();
  const [openSummary, setOpenSummary] = useState(false);
  const [openAddCategory, setOpenAddCategory] = useState(false);
  const fetchCategories = async (id?: number) => {
    try {
      const categories = await getAllCategories(dispatch);
      setCategories(categories);
      if (id) {
        const category = categories.find((x: any) => x.id === id);
        if (category) {
          setSelectedCategory(category);
          setOpenSummary(true);
        }
      }
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al obtener las categorías');
    }
  };

  const setUp = async (id?: number) => {
    setLoading(true);
    setOpenSummary(false);
    await fetchCategories(id);
    setLoading(false);
  };

  useEffect(() => {
    void setUp();
  }, []);

  const handleAddCategory = () => {
    setOpenAddCategory(true);
  };

  const handleOpenSummary = (categoryId: number) => {
    const category = categories.find((x) => x.id === categoryId);
    if (!category) return alert('Ha ocurrido un error');
    console.log('Abrir Categoría', category);
    setSelectedCategory(category);
    setOpenSummary(true);
  };

  const buttons: CustomButtonProps[] = [
    {
      name: 'Agregar Categoría',
      action: () => handleAddCategory(),
      color: 'primary',
    },
  ];

  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <HeaderWithActions
        title="Acá podrás configurar categorias y sus tags asociados."
        variant={'body1'}
        buttons={buttons}
      />
      <EnhancedTable
        dataHeaders={[
          { key: 'name', label: 'Categoría' },
          { key: 'description', label: 'Descripción' },
          {
            key: 'tagsNames',
            label: 'Tags',
          },
        ]}
        data={categories}
        handleClickRow={handleOpenSummary}
        rowsPerPageDefault={10}
        lastElement
      />
      {openSummary && (
        <CategorySummary
          category={selectedCategory}
          open={openSummary}
          onClose={() => setOpenSummary(false)}
          setUp={setUp}
        />
      )}
      {openAddCategory && (
        <AddCategory
          open={openAddCategory}
          onClose={() => setOpenAddCategory(false)}
          setUp={setUp}
        />
      )}
    </div>
  );
};

export default Categories;
